import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../api';
import { t } from '../i18n';
import { Feld, Fehler } from '../components/ui';

/** Geführte Ersteinrichtung (DoD 1): Organisation + Admin-Konto. */
export function SetupPage() {
  const [orgName, setOrgName] = useState('');
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [allowed, setAllowed] = useState<boolean | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get<{ needsSetup: boolean }>('/api/v1/auth/setup-status')
      .then((s) => setAllowed(s.needsSetup))
      .catch(() => setAllowed(false));
  }, []);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (password.length < 12) {
      setError('PASSWORD_TOO_SHORT');
      return;
    }
    setBusy(true);
    try {
      await api.post('/api/v1/auth/setup', {
        organizationName: orgName,
        adminEmail: email,
        adminDisplayName: displayName,
        adminPassword: password,
      });
      navigate('/anmelden', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.code : 'INTERNAL');
    } finally {
      setBusy(false);
    }
  }

  if (allowed === null) return <p style={{ padding: '2rem' }}>{t('app.loading')}</p>;

  return (
    <div className="auth-rahmen">
      <div className="logo-block">
        <img src="/logo.svg" alt="WerkDelta" />
      </div>
      <div className="karte">
        <h1>{t('auth.setup.title')}</h1>
        {!allowed ? (
          <p>{t('auth.setup.alreadyDone')}</p>
        ) : (
          <form onSubmit={submit}>
            <p className="erklaerung">{t('auth.setup.intro')}</p>
            <Feld label={t('auth.setup.orgName')} required>
              <input value={orgName} onChange={(e) => setOrgName(e.target.value)} required />
            </Feld>
            <Feld label={t('auth.setup.adminName')} required>
              <input
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                required
              />
            </Feld>
            <Feld label={t('auth.email')} required>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </Feld>
            <Feld label={t('auth.password')} required hint={t('auth.setup.passwordHint')}>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                required
                minLength={12}
              />
            </Feld>
            <Fehler code={error} />
            <div className="aktionen">
              <button type="submit" className="knopf-primaer" disabled={busy}>
                {t('auth.setup.action')}
              </button>
            </div>
            <p className="erklaerung">{t('auth.setup.mfaNote')}</p>
          </form>
        )}
      </div>
    </div>
  );
}
